export default "__VITE_ASSET__DCvxbWrj__"